var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[(_vm.type === 'wells')?_c('WellsBreadcrumb',{attrs:{"links":_vm.links}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }